import React, { useEffect } from 'react';
import { useDataEdit } from 'hooks/use-data-edit';
import { useTopNav } from 'components/common/top-nav/hooks';
import { redirect } from 'lib/location';
import { useEntityLogs } from 'components/common/entity-logs/hooks';
import { useTable } from 'components/common/table/hooks';

export const useProfile = ({ pageProps }) => {
  const { _id, mode, collection, metadata, isLoading, isEditMode, isCopyMode } = pageProps;
  const url = isEditMode
    ? `/api/collection/${collection}/edit/${_id}`
    : isCopyMode
    ? `/api/collection/${collection}/copy/${_id}`
    : `/api/collection/${collection}/new`;
  const { Component: EntityLogs, refetch: refetchLogs } = useEntityLogs({ _id });
  const { setTopNav } = useTopNav();
  const { body, data, config, controller, save, canSave, inputs } = useDataEdit({
    mode,
    value: pageProps,
    config: { editable: false, ...pageProps },
    url,
    refetch: () => {
      pageProps?.fetchPageData();
      refetchLogs();
    },
    success:
      mode === 'new' || mode === 'copy'
        ? (result) => {
            if (result && result?._id) {
              redirect(`/${collection}/profile/${result._id}`);
            }
          }
        : undefined
  });

  const { data: itemOptions = [] } = useTable({
    collection: 'user',
    url: '/api/collection/item/listing',
    paramsPreset: {
      pageSize: 100000
    }
  });

  const { data: parentIsCategoryOptions = [] } = useTable({
    url: '/api/collection/item/parent-is-category-items/listing',
    paramsPreset: {
      pageSize: 100000
    }
  });

  const { schema, fieldsToDisplay = [], isEdit } = config;
  const { setInputs } = controller;

  useEffect(() => {
    const copy = isEdit
      ? () => {
          redirect(`/${collection}/copy/${_id}`);
        }
      : null;
    setTopNav({ save, canSave, copy });
  }, [save, canSave, isEdit, _id]);

  useEffect(() => {
    setTopNav({ save, canSave });
  }, [save, canSave]);

  return {
    _id,
    data,
    body,
    parentIsCategoryOptions,
    itemOptions,
    config,
    controller,
    save,
    canSave,
    metadata,
    schema,
    fieldsToDisplay,
    setInputs,
    inputs,
    isLoading,
    isCopyMode,
    EntityLogs
  };
};
